import React from "react";
import pp from '../asset/pp.png';

const About = () => {
    return(
    <section id="about" className="py-20 bg-custom-orange">
        <div className="container mx-auto text-center px-6">
            <h2 className="text-4xl font-bold mb-8 text-gray-800">
                Tentang saya
            </h2>
            <div className="flex flex-col items-center mb-12">
                <img src={`${pp}`} alt="Profile " className="w-32 h-32 rounded-full object-cover mb-4 shadow-lg"/>
                <p className="text-lg text-gray-600 mb-2">Kidi intern</p>
                <p className="text-xl text-gray-700 font-semiold">I'm a software engineer intern in Kidi , Telkom Educourse</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className=" border border-custom-green2 bg-custom-orange p-6 rounded-lg shadow-lg  hover:bg-custom-orange transition-colors duration-300">
                <h3 className="text-2xl font-bold mb-4 text-custom-green2">UI/UX</h3>
                <p className="text-gray-700 mb-4 ">
                    Dalam desain digital,antarmuka pengguna (UI) mengacu pada interaktivitas, tampilan, dan nuansa layar produk atau halaman web, sedangkan penglaman pengguna (UX) mencangkup keseluruhan penglaman pengguna dengan produk atau situs web.
                </p>
            </div>
            <div className="bg-custom-green2 p-6 rounded-lg shadow-lg hover:bg-custom-green2 transition-colors duration-300">
                <h3 className="text-2xl font-bold mb-4 text-custom-orange">React Js </h3>
                <p className=" text-custom-orange mb-4 ">
                    React Js adalah pustaka JavaScript yang di gunakan untuk membangun antarmuka pengguna yang interaktif. React Js merupakan library JavaScript yang populer dan open source.
                </p>
            </div>
            <div className="border border-custom-green2 bg-custom-orange p-6 rounded-lg shadow-lg hover:bg-custom-orange transition-colors duration-300">
                <h3 className="text-2xl font-bold mb-4 text-custom-green2">Node Js</h3>
                <p className="text-gray-700 mb-4 ">
                    Node Js adalah runtime envoinment untuk Java Script yang bersifat open source dan cross-platform.
                </p>
            </div>
            </div>
        </div>
    </section>
    )
}

export default About;